export default __webpack_public_path__ + "static/media/circuit_building.a7236ba6.jpg";